import { countryState } from '@core/country/stores/country.store'
import { languageState } from '@core/dictionary'
import { useAtomValue } from 'jotai'

export const getLocale = (
    country: { shorter: string; config: { languageSettings: { default: string; items: Array<{ code: string; locale?: string }> } } },
    language?: string
) => {
    const settings = country.config.languageSettings
    const code = language?.toUpperCase() === 'JP' ? 'JA' : language?.toUpperCase()
    return (
        settings.items.find(item => item.code === code)?.locale ||
        settings.items.find(item => item.code === settings.default)?.locale ||
        `en-${country.shorter || 'US'}`
    )
}

export function useLocale() {
    const country = useAtomValue(countryState)
    const language = useAtomValue(languageState)

    return {
        locale: getLocale(country, language),
        language
    }
}
